import {ToolbarButton, 
    Dialog,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogTrigger,
    Button,
    DialogContent,
    useToastController} from "@fluentui/react-components";
import {useState} from "react";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';
import { SubmitCasualMonthly } from "../../services/apiService";
import { showErrorToast, showSuccessToast, TOASTER_ID } from "../../services/toastUtils";
import TooltipWatcherWidget from "../TooltipWatcherWidget";

export default function CasualMonthlySubmit({ onSubmit }) {
    const [open, setOpen] = useState(false);
    const {useStyles, startLoad, endLoad, currentWeekStart} = useGlobalStatus();
    const styles = useStyles();
    const { dispatchToast } = useToastController(TOASTER_ID);

    const checkConfigStatus = async() => {
        setOpen(true);          
    }

    const handleCasualMonthlySubmit = async() => {
        startLoad();
        try {
            await SubmitCasualMonthly(currentWeekStart);
            showSuccessToast(dispatchToast, "Successfully submitted timesheet");
            await onSubmit();
        } catch {
            showErrorToast(dispatchToast, "Failed to submit timesheet");
        }
        endLoad();
    }
    
    return <>
    <Dialog open={open}>
        <DialogTrigger disableButtonEnhancement>
            <TooltipWatcherWidget text="End of month submission to be done before weekly timesheet" direction="above-end">
                <ToolbarButton 
                className={styles.buttonStrong}
                onClick={()=>checkConfigStatus()} 
                disabled={false}
                >Submit Monthly Entries
                </ToolbarButton>
            </TooltipWatcherWidget>
        </DialogTrigger>
        <DialogSurface>
            <DialogBody>
                <DialogTitle><strong>Confirm Monthly Submission</strong></DialogTitle>
                <DialogContent>
                    Submitting will lock your entries for the month. You should do this once you've completed all entries for the month — even if it's midweek.<br/>
                </DialogContent>
                <DialogActions>
                    <Button className={styles.buttonPrimary} 
                                onClick={() => {
                                    handleCasualMonthlySubmit();
                                    setOpen(false);
                                }}>Submit</Button>
                    <DialogTrigger disableButtonEnhancement>
                        <Button appearance="secondary"  onClick={() => setOpen(false)}>Cancel</Button>
                    </DialogTrigger>
                </DialogActions>
            </DialogBody>
        </DialogSurface>
    </Dialog>
    </>
}